import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { BuilderPage } from './BuilderPage';

export default function BuilderPageWrapper() {
  const [searchType, setSearchType] = useState('Nama Member');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const handleSearchTypeChange = (newSearchType: string) => {
    setSearchType(newSearchType);
    setSearchQuery('');
    setCurrentPage(1);
  };

  return (
    <div className="d-flex flex-column flex-grow-1 px-4 py-3">
      <div style={{ 
        position: 'relative', 
        zIndex: 1,
        marginTop: '-65px'
      }}>
        <BuilderPage 
          searchType={searchType}
          searchQuery={searchQuery}
          onSearchTypeChange={handleSearchTypeChange}
          onSearchQueryChange={setSearchQuery}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
      </div>
    </div>
  );
}
